// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-radial-gradient {
  background-color: hsl(218, 41%, 15%);
  background-image: radial-gradient(
      650px circle at 0% 0%,
      hsl(218, 41%, 35%) 15%,
      hsl(218, 41%, 30%) 35%,
      hsl(218, 41%, 20%) 75%,
      hsl(218, 41%, 19%) 80%,
      transparent 100%
    ),
    radial-gradient(
      1250px circle at 100% 100%,
      hsl(218, 41%, 45%) 15%,
      hsl(218, 41%, 30%) 35%,
      hsl(218, 41%, 20%) 75%,
      hsl(218, 41%, 19%) 80%,
      transparent 100%
    );
  height: 103.7vh;
}

#radius-shape-1 {
  height: 220px;
  width: 220px;
  top: -60px;
  left: -130px;
  background: radial-gradient(#44006b, #ad1fff);
  overflow: hidden;
}

#radius-shape-2 {
  border-radius: 38% 62% 63% 37% / 70% 33% 67% 30%;
  bottom: -60px;
  right: -110px;
  width: 300px;
  height: 300px;
  background: radial-gradient(#44006b, #ad1fff);
  overflow: hidden;
}

.bg-glass {
  background-color: hsla(0, 0%, 100%, 0.9) !important;
  backdrop-filter: saturate(200%) blur(25px);
  width: 80%;
  margin-left: 0%;
  margin-right: 40%;
  border-radius: 5px;
  height: 100%;
  margin-top: 20px;
}

.poise {
  display: flex;
  margin-top: 30px;
  padding-bottom: 70px;
}

.shapesArea {
  width: 50%;
}

.formArea {
  width: 50%;
  height: 320px;
}

.dataHere {
  width: 80%;
  height: 40px;
  margin-top: 20px;
  border-radius: 5px;
  border: 1px solid grey;
  padding: 5px;
  padding-left: 15px;
  padding-right: 15px;
}

.submitButtonHere {
  width: 87%;
  height: 40px;
  margin-top: 30px;
  background-color: #3f73cb;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 15px;
  line-height: 40px;
  padding-bottom: 5px;
  font-weight: 400;
}

.TopHere {
  margin-top: -55px;
  /* padding-top: 30px; */
  /* display: flex; */
}

.instructions {
  /* color: #a7bce2; */
  color: white;
  text-align: left;
  padding-left: 30px;
}

.instructions ul {
  text-align: left;
  font-size: 15px;
  padding-left: 15px;
}

.pom5 {
  padding: 20px;
}

.bold {
  color: red;
}

.submitButtonHere:focus,
.submitButtonHere:active {
  transform: none;
  outline: none;
  box-shadow: none;
}

.logo {
  height: 150px;
  margin-top: -45px;
  /* padding-left: 22px; */
}

.logo2 {
  height: 150px;
  margin-left: -150px;
}

.pom4 {
  text-align: center;
  justify-content: center;
}

.testPageStartsHere {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Css/LoginForm.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC;;;;;;;;;;;;;;;KAeG;EACH,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,aAAa;EACb,YAAY;EACZ,aAAa;EACb,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,0CAA0C;EAC1C,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".background-radial-gradient {\r\n  background-color: hsl(218, 41%, 15%);\r\n  background-image: radial-gradient(\r\n      650px circle at 0% 0%,\r\n      hsl(218, 41%, 35%) 15%,\r\n      hsl(218, 41%, 30%) 35%,\r\n      hsl(218, 41%, 20%) 75%,\r\n      hsl(218, 41%, 19%) 80%,\r\n      transparent 100%\r\n    ),\r\n    radial-gradient(\r\n      1250px circle at 100% 100%,\r\n      hsl(218, 41%, 45%) 15%,\r\n      hsl(218, 41%, 30%) 35%,\r\n      hsl(218, 41%, 20%) 75%,\r\n      hsl(218, 41%, 19%) 80%,\r\n      transparent 100%\r\n    );\r\n  height: 103.7vh;\r\n}\r\n\r\n#radius-shape-1 {\r\n  height: 220px;\r\n  width: 220px;\r\n  top: -60px;\r\n  left: -130px;\r\n  background: radial-gradient(#44006b, #ad1fff);\r\n  overflow: hidden;\r\n}\r\n\r\n#radius-shape-2 {\r\n  border-radius: 38% 62% 63% 37% / 70% 33% 67% 30%;\r\n  bottom: -60px;\r\n  right: -110px;\r\n  width: 300px;\r\n  height: 300px;\r\n  background: radial-gradient(#44006b, #ad1fff);\r\n  overflow: hidden;\r\n}\r\n\r\n.bg-glass {\r\n  background-color: hsla(0, 0%, 100%, 0.9) !important;\r\n  backdrop-filter: saturate(200%) blur(25px);\r\n  width: 80%;\r\n  margin-left: 0%;\r\n  margin-right: 40%;\r\n  border-radius: 5px;\r\n  height: 100%;\r\n  margin-top: 20px;\r\n}\r\n\r\n.poise {\r\n  display: flex;\r\n  margin-top: 30px;\r\n  padding-bottom: 70px;\r\n}\r\n\r\n.shapesArea {\r\n  width: 50%;\r\n}\r\n\r\n.formArea {\r\n  width: 50%;\r\n  height: 320px;\r\n}\r\n\r\n.dataHere {\r\n  width: 80%;\r\n  height: 40px;\r\n  margin-top: 20px;\r\n  border-radius: 5px;\r\n  border: 1px solid grey;\r\n  padding: 5px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.submitButtonHere {\r\n  width: 87%;\r\n  height: 40px;\r\n  margin-top: 30px;\r\n  background-color: #3f73cb;\r\n  border: none;\r\n  border-radius: 5px;\r\n  color: white;\r\n  font-size: 15px;\r\n  line-height: 40px;\r\n  padding-bottom: 5px;\r\n  font-weight: 400;\r\n}\r\n\r\n.TopHere {\r\n  margin-top: -55px;\r\n  /* padding-top: 30px; */\r\n  /* display: flex; */\r\n}\r\n\r\n.instructions {\r\n  /* color: #a7bce2; */\r\n  color: white;\r\n  text-align: left;\r\n  padding-left: 30px;\r\n}\r\n\r\n.instructions ul {\r\n  text-align: left;\r\n  font-size: 15px;\r\n  padding-left: 15px;\r\n}\r\n\r\n.pom5 {\r\n  padding: 20px;\r\n}\r\n\r\n.bold {\r\n  color: red;\r\n}\r\n\r\n.submitButtonHere:focus,\r\n.submitButtonHere:active {\r\n  transform: none;\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.logo {\r\n  height: 150px;\r\n  margin-top: -45px;\r\n  /* padding-left: 22px; */\r\n}\r\n\r\n.logo2 {\r\n  height: 150px;\r\n  margin-left: -150px;\r\n}\r\n\r\n.pom4 {\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n\r\n.testPageStartsHere {\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
